/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createLoadingSelector, createErrorSelector, errorActions } from "@a1/core";
import { processActions } from "../../reducer/processReducer";

import logoSplash from "../../images/logo_splash.png";

const actionsNames = ["FORGOTTEN_PASS_CHECK_TOKEN", "FORGOTTEN_PASS_NEW_PASS"];

class ForgottenPassNew extends Component {
  state = {
    token: "",
    tokenTemp: "",
    password: "",
    passwordError: "",
    password2: "",
    password2Error: "",
    mustValidateData: false,
  };

  componentDidMount() {
    document.title = "Забравена парола - New - A1 Xplore TV GO";

    const { token } = this.state;
    const { history, clearErrors, forgottenPassCheckToken } = this.props;

    clearErrors(actionsNames);

    if (token === "") {
      const tokenParts = history.location.pathname.split("/");
      const tokenString = tokenParts && tokenParts.length > 2 ? tokenParts[2] : "";

      if (tokenString !== "" && tokenString !== null) {
        // this.setState({ token: tokenString });
        this.setState({ tokenTemp: tokenString });
        forgottenPassCheckToken(tokenString);
      } else {
        // history.push('/passrecovery');
        window.location.href = "https://new.a1xploretv.bg/login";
        return false;
      }
    }

    this.handleAutofocus();
    return false;
  }

  componentDidUpdate(prevProps) {
    const { tokenTemp } = this.state;
    const { loading, history, process, error } = this.props;

    if (
      !loading &&
      !(error && error.length) &&
      !(process.forgottenPassCheckTokenResult && process.forgottenPassCheckTokenResult.error) &&
      !(process.forgottenPassNewPassResult && process.forgottenPassNewPassResult.error)
    ) {
      // Typical usage (don't forget to compare props):

      if (
        process.forgottenPassNewPassResult &&
        process.forgottenPassNewPassResult.isOk === true &&
        process.forgottenPassNewPassResult !== prevProps.process.forgottenPassNewPassResult
      ) {
        history.push("/recoverypass-finish");
        return false;
      }

      if (
        tokenTemp &&
        process.forgottenPassCheckTokenResult &&
        process.forgottenPassCheckTokenResult.isOk === true &&
        process.forgottenPassCheckTokenResult !== prevProps.process.forgottenPassCheckTokenResult
      ) {
        this.tokenValidated(tokenTemp);
        return false;
      }
    }

    return false;
  }

  tokenValidated = tokenTemp => {
    this.setState({ token: tokenTemp });
    this.setState({ tokenTemp: "" });
  };

  handleInputChange = event => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    const { mustValidateData } = this.state;

    this.setState({
      [name]: value,
    });

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleInputOnKeyUp = event => {
    const { mustValidateData } = this.state;

    if (event.keyCode === 13) {
      this.handleNextClick();
    }

    if (mustValidateData === true) {
      this.validateData();
    }
  };

  handleAutofocus = () => {
    const autofocusElements = document.getElementsByClassName("autofocus");
    if (autofocusElements && autofocusElements.length > 0) {
      autofocusElements[0].focus();
    }
  };

  handleInpOnClick = event => {
    event.target.previousSibling.focus();
  };

  handleInpOnFocus = event => {
    event.currentTarget.parentNode.classList.add("active");
  };

  handleInpOnBlur = event => {
    const targetCurrent = event.target;
    const targetParent = targetCurrent.parentNode;
    if (!targetCurrent.value.length) {
      targetParent.classList.remove("active");
    }
  };

  handlePassShowHide = event => {
    const targetCurrent = event.target;
    const targetInput = targetCurrent.previousSibling.previousSibling;
    if (targetInput.type.toLowerCase() === "password") {
      targetInput.type = "text";
      targetCurrent.classList.add("show");
    } else {
      targetInput.type = "password";
      targetCurrent.classList.remove("show");
    }
  };

  handleNextClick = () => {
    const { token, password, mustValidateData } = this.state;
    const { forgottenPassNewPass } = this.props;

    if (!mustValidateData) {
      this.setState({ mustValidateData: true });
    }

    if (this.validateData()) {
      forgottenPassNewPass(token, password);
    }

    return false;
  };

  validateData = () => {
    const { password, password2 } = this.state;

    let isValidPassword = true;
    let isValidPassword2 = true;

    if (!(password.length > 0)) {
      isValidPassword = false;
      this.setState({
        passwordError: "Въведената парола е грешна. Паролата трябва да съдържа минимум 4 символа, без интервали.",
      });
    } else if (password.length < 4) {
      isValidPassword = false;
      this.setState({
        passwordError: "Паролата трябва да съдържа минимум 4 символа, без интервали. Моля, опитай отново.",
      });
    }
    if (isValidPassword) this.setState({ passwordError: "" });

    if (!(password2.length > 0)) {
      isValidPassword2 = false;
      this.setState({ password2Error: "Моля, въведи отново паролата си." });
    } else if (password !== password2) {
      isValidPassword2 = false;
      this.setState({
        password2Error: "Въведените пароли не съвпадат. Моля, въведи ги отново.",
      });
    }
    if (isValidPassword2) this.setState({ password2Error: "" });

    return isValidPassword && isValidPassword2;
  };

  render() {
    const { token, password, passwordError, password2, password2Error } = this.state;

    const { process, loading, error } = this.props;
    const requestError = error && error.length ? error.map(err => <p>{err}</p>) : null;

    const divLoading = loading ? (
      <div className="loading">
        <div className="spinner-border" />
      </div>
    ) : null;

    let divError = null;
    if (requestError) divError = requestError;
    else if (process.forgottenPassCheckTokenResult && process.forgottenPassCheckTokenResult.error)
      divError = process.forgottenPassCheckTokenResult.error;
    else if (process.forgottenPassNewPassResult && process.forgottenPassNewPassResult.error)
      divError = process.forgottenPassNewPassResult.error;

    divError = divError ? <div className="error error-main">{divError}</div> : null;

    // <div className="tag-content" style={{ marginTop: '80px' }}>
    //  <a href="https://new.a1xploretv.bg/login" className="tag-btn tag-btn--active">
    //    Назад
    //  </a>
    // </div>

    const divPasswordError = passwordError ? <div className="error">{passwordError}</div> : null;
    const divPassword2Error = password2Error ? <div className="error">{password2Error}</div> : null;

    let containerBody = null;

    if (token || divError) {
      if (divError) {
        containerBody = (
          <>
            <h1 className="tag-title">Грешка</h1>
            {divError}
          </>
        );
      } else {
        containerBody = (
          <div className="container-body">
            <h1 className="tag-title">Въведи новата парола</h1>
            <div className="tag-textfield">
              <input
                name="password"
                type="password"
                id="password"
                className="tag-input"
                value={password}
                onFocus={this.handleInpOnFocus}
                onBlur={this.handleInpOnBlur}
                onChange={this.handleInputChange}
                onKeyUp={this.handleInputOnKeyUp}
              />
              <label htmlFor="password" onClick={this.handlePassOnClick}>
                Парола
              </label>
              <div className="tag-textfield_hide_show" onClick={this.handlePassShowHide} />
              {divPasswordError}
            </div>

            <div className="tag-textfield">
              <input
                name="password2"
                type="password"
                id="password2"
                className="tag-input"
                value={password2}
                onFocus={this.handleInpOnFocus}
                onBlur={this.handleInpOnBlur}
                onChange={this.handleInputChange}
                onKeyUp={this.handleInputOnKeyUp}
              />
              <label htmlFor="password2" onClick={this.handlePassOnClick}>
                Повтори паролата
              </label>
              <div className="tag-textfield_hide_show" onClick={this.handlePassShowHide} />
              {divPassword2Error}
            </div>

            <div className="tag-content" style={{ marginTop: "80px" }}>
              <button
                type="button"
                className="tag-btn tag-btn--active"
                onClick={this.handleNextClick}
                disabled={!!loading}
              >
                Продължи
              </button>
            </div>

            <div className="tag-content tag-content__help">
              Имаш въпроси?{" "}
              <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
                Помощ
              </a>
            </div>
          </div>
        );
      }
    }

    return (
      <div className="page page-register">
        <div className="header-bg" />

        <div className="container container--small">
          {divLoading}

          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>

          {containerBody}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
    loading: createLoadingSelector(actionsNames)(state),
    error: createErrorSelector(actionsNames)(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearErrors: actions => dispatch(errorActions.clearErrors(actions)),
    forgottenPassCheckToken: token => dispatch(processActions.forgottenPassCheckToken(token)),
    forgottenPassNewPass: (token, password) => dispatch(processActions.forgottenPassNewPass(token, password)),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ForgottenPassNew);
